import { Pipe, PipeTransform } from '@angular/core';
import { GeneralService } from '../../core';
/*
 * Gets column value depending on column type and suffix
 * Default returns as string.
 * If value in underfine or null returns '-'
 * Example:
 *   row[column.columnDef] | tableCellPipe: column
*/
@Pipe({
    name: 'tableCellPipe',
    pure: true
})
export class TableCellTextPipe implements PipeTransform {
    constructor(private generalService: GeneralService) {}

    transform(value: any, column: any): string {
        if(value == null || value === '') return '-';
        // Switch state
        if(!column.suffix && !column.type)
            return value;
        else if(column.type && column.type === 'date')
            return this.generalService.parseDate(value)
        else if(column.type && column.type === 'vat')
            return this.generalService.parseVAT(value).toFixed(0).toString() + ' %'
        else if(!column.type && column.suffix && column.suffix === 'percentage')
            return value.toString() + ' %'
        else if(column.type && column.type === 'margin')
            return this.generalService.parseVAT(value).toFixed(1).toString() + ' %'
        else if(column.suffix && column.suffix === 'currency')
            return value.toFixed(2).toString() + ' zł';
        else if(column.suffix && column.suffix === 'boolean'){
            console.log("Wywołuje się");
            return value ? "Tak" : 'Nie';
        }
        return value;
    }
}
